export default __webpack_public_path__ + "static/px2-22e207625cd3cfbccbaa8cbe355d164e.jpg";